import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import style from "./style";

@define("m-modal-educash")
class modalEducash extends HTMLElement {
  #close = true;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
    <div class="${style.modal__overlay}" close="${this.#close}">
      <div class="${style.modal}" close="${this.#close}">
        <img src=//donna.sistemadulino.com.br/rocket.png alt="foguete" />
        <div class="${style.modal__texts}">
          <div class="${style.modal__congratulations}">
            <span>Parabéns</span>
            <span>Voce ganhou ${this.dataset.value} pontos!</span>
          </div>
          <span>Continue assim e muitos outros sucessos virão!</span>
        </div>
        <button class="${style.modal__button}">
          <span>Continuar</span>
        </button>
      </div>
    </div>

    `;
  }

  @on.click("button")
  @repaint
  async [trait.close]() {
    await supabase
      .from("educash")
      .insert([
        {
          educash_type: this.dataset.type,
          user_id: this.dataset.user,
          video_id: this.dataset.video,
          value: this.dataset.value,
        },
      ])
      .select();

    this.#close = false;
    window.location.reload();
    return this;
  }
}

export default modalEducash;
